import React from 'react'

const WD = () => {
  return (
    <div>
        {/* collapseThree */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseThree"
                    aria-expanded="false" aria-controls="collapseThree">
                    Frontend
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>HTML 5 (Hyper Text Markup Language)</strong>:
                    <ul>
                      <li>Introduction to HTML and their versions</li>
                      <li>Tags and their attributes</li>
                      <li>Advance HTML tags like forms, frames, tables,etc.</li>
                      <li>Basic Webpage & Website design</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>CSS3 (Cascading Style Sheet)</strong>:
                    <ul>
                      <li>Introduction to CSS and Their versions</li>
                      <li>Types of Style Sheets</li>
                      <li>CSS Properties</li>
                      <li>CSS Selectors</li>
                      <li>Absolute and Relative positioning, DIV + CSS</li>
                      <li>CSS Gradient & Layouts</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>Bootstrap</strong>:
                    <ul>
                      <li>Bootstrap - Home, Overview, Environment Setup</li>
                      <li>Bootstrap - Grid System, CSS Overview, Typography, code, Tables, Forms, Buttons images</li>
                      <li>Bootstrap - Responsive utilities</li>
                      <li>Bootstrap Plugins, Plugins Overview, Transition Plugin, Modal Plugin, Dropdown plugin, Scrollspy Plugin, -Tab Plugin, Tooltip Plugin, Popover Plugin, Alert Plugin, </li>
                      <li>Button Plugin, Collapse Plugin</li>
                      <li>Flex</li>
                      <li>Bootstrap Demos ( Practice Sessions )</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>JavaScript</strong>:
                    <ul>
                      <li>Introduction to Scripting & javascript</li>
                      <li>Javascript variables & operators.</li>
                      <li>Javascript Looping statements, Events & Functions, DOM & BOM</li>
                      <li>JS Popup Boxes</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>Jquery</strong>:
                    <ul>
                      <li>Jquery overview, Basics, Selectors, Attributes</li>
                      <li>JQuery traversing</li>
                      <li>JQuery effects, Jquery events</li>
                      <li>JQuery HTML / CSS, Jquery forms</li>
                      <li>JQuery Ajax, JQuery UI</li>
                    </ul>

                    <strong>Portfolio Designing Task</strong>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default WD